import { builder } from 'common/js/configs';
import { units } from 'common/js/configs/constants';

export const commonExpandBtn = {
  expandBtn: builder.holder({
    iconColor: builder.color('expand_icon_color', {
      defaultValue: '#FFFFFF',
      l:'',
      d:''
    }),
    largeClickableZonePadding: builder.number(
      'expand_btn_large_clickable_zone_padding',
      {
        defaultValue: 0,
        l:'',
        d:'',
        unit: units.pixel
      }
    ),
    position: builder.string('expand_btn_position', {
      of: ['right', 'left'],
      possibleValues: [
        {
          name: 'Left',
          value: 'left'
        },
        {
          name: 'Right',
          value: 'right'
        }
      ],
      defaultValue: 'right',
      l:'',
      d:''
    }),
    iconSize: builder.number('expand_btn_size', {
      defaultValue: 12,
      l:'',
      d:'',
      unit: units.pixel
    }),
    paddingSize: builder.number('expand_btn_padding_size', {
      defaultValue: 2,
      l:'',
      d:'',
      unit: units.pixel
    }),
    showExpandBtn: builder.boolean('show_expand_button', {
      defaultValue: false,
      l:'',
      d:''
    })
  })
};
